import React, { useState } from "react";
import useAppNavigate from "../../../hooks/useAppNavigate";
import {
  getFormData,
  getWebFormData,
  updateWebFormData,
} from "../../../../utils/pip";
import { useLocation, useNavigate } from "react-router-dom";
import { adminPaths } from "../../../../routes/admin";
import { coachPaths } from "../../../../routes/coach";

const Step0 = ({ step, setStep, isWebinar }) => {
  const { pathname } = useLocation()
  const navigate = useNavigate();

  const handleStep0 = (values) => {
    updateWebFormData("step0", values);
    setStep(1);
    if (pathname == coachPaths?.Event) {
      if (isWebinar == "webinar") {
        navigate(coachPaths.AddCoachWebinar, { state: { data: values } })
      } else if (isWebinar == "workshop") {
        navigate(coachPaths?.AddCoachWorkShop, { state: { data: values } });
      }
    } else {
      if (isWebinar == "webinar") {
        navigate(adminPaths?.AddWebinar, { state: { data: values } });
      } else if (isWebinar == "workshop") {
        navigate(adminPaths?.AddWorkshop, { state: { data: values } });
      };
    };
  };

  return (
    <div class="modal-body  p-4 pt-0">
      <h4 class="ct_fw_600 text-center mb-4 ct_fs_20  px-4">
        Select Speaker Type
      </h4>
      <div class="row">
        <div class="col-md-6 mb-4 mb-md-0">
          <div class="ct_light_grey_bg" onClick={() => {
            handleStep0({ speakerType: "Single" })
          }}>
            <img src="../assets/img/SingleSpeaker.png" alt="" />
            <p class="mb-0 ct_fs_16 text-center">Single Speaker</p>
          </div>
        </div>
        <div class="col-md-6 mb-4 mb-md-0">
          <div
            class="ct_light_grey_bg"
            onClick={() => {
              handleStep0({ speakerType: "Multiple" })
            }}
          >
            <img src="../assets/img/MulTipleSpeakerIcon.png" alt="" />
            <p class="mb-0 ct_fs_16 text-center">Multiple Speaker</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step0;